import React, { useContext, useEffect } from 'react';
import AppContext from '@context';
import { FuelModal } from '@frete.com/fuel-station-react';
import useAmplitude from '@hooks/useAmplitude';
import Header from './Header';
import * as Styled from './ModalListConfirmDeliveryStyles';
import JourneysList from './JourneysList';

function ModalListConfirmDelivery() {
  const { amplitudeEvent } = useAmplitude();
  const {
    state: { ui, journeysWaitingConfirmDelivery },
    dispatch,
  } = useContext(AppContext);
  const { data: journeys } = journeysWaitingConfirmDelivery;
  const { isShow } = ui.modalJourneyWaitingConfirmDelivery;

  function handleClose() {
    dispatch({
      type: 'ui_modal_journey_waiting_confirm_delivery_set_show',
      payload: { isShow: false },
    });
  }

  useEffect(() => {
    if (isShow && journeys.length) {
      document.body.classList.add('journey--overflowYHidden');
      amplitudeEvent('modal_list_confirm_delivery_show');
    }

    if (isShow && !journeys.length) {
      handleClose();
    }

    return () => {
      document.body.classList.remove('journey--overflowYHidden');
    };
  }, [isShow, journeys]);

  return (
    <FuelModal
      isOpen={isShow}
      onClose={() => handleClose()}
      portalName="portal-modal-confirm-delivery"
      width="lg"
    >
      <Styled.Wrapper>
        <Header onClose={() => handleClose()} />
        <JourneysList />
      </Styled.Wrapper>
    </FuelModal>
  );
}

export default ModalListConfirmDelivery;
